import { VoucherCategory, VoucherTypeIds } from '../vouchers/index.js';
export const getCaseVoucherTables = (customTables, lang) => {
    let tables = DefaultCaseVoucherTables(lang);
    tables = tables.concat(customTables);
    return tables;
};
const DefaultCaseVoucherTables = (lang) => [
    {
        name: lang.caseVoucherTableLabels.overview,
        description: lang.caseVoucherTableLabels.overview,
        handle: 'DKoverview',
        groupBy: [
            {
                label: lang.mentionContent.reminderFeeRow,
                voucherTypeIds: [VoucherTypeIds.REMINDERFEE],
            },
            {
                label: lang.mentionContent.debtCollectionFeeRow,
                voucherTypeIds: [VoucherTypeIds.COLLECTIONFEE],
            },
            {
                label: lang.mentionContent.debtCollectionCostRow,
                voucherTypeIds: [VoucherTypeIds.COLLECTIONCOST],
            },
            {
                label: lang.mentionContent.compensationFeeRow,
                voucherTypeIds: [VoucherTypeIds.COMPENSATIONCOST],
            },
            {
                label: lang.mentionContent.processInterestRow,
                voucherTypeIds: [VoucherTypeIds.PROCESSINTEREST],
            },
            {
                label: lang.mentionContent.fixedInterestRow,
                voucherTypeIds: [VoucherTypeIds.FIXEDINTEREST],
            },
            {
                label: lang.mentionContent.yearlyInterestRow,
                voucherTypeIds: [VoucherTypeIds.YEARLYINTEREST],
            },
            {
                label: lang.mentionContent.paid,
                voucherTypeIds: [VoucherTypeIds.DEPOSIT],
            },
        ],
        includeDeleted: false,
        excludeHeader: true,
    },
    {
        name: lang.caseVoucherTableLabels.detailed,
        description: lang.caseVoucherTableLabels.detailed,
        handle: 'detailed',
        groupBy: [],
        includeDeleted: false,
        excludeHeader: true,
    },
    {
        name: lang.caseVoucherTableLabels.principalWithReferenceCaseVouchers,
        description: lang.caseVoucherTableLabels.principalWithReferenceCaseVouchers,
        handle: 'principalWithReferenceCaseVouchers',
        groupBy: [],
        includeDeleted: false,
        include: [
            {
                categories: [VoucherCategory.PRINCIPAL],
                includeReferenceCaseVouchers: true,
            },
        ],
        excludeSumRow: true,
        excludeHeader: true,
    },
];
//# sourceMappingURL=tables.js.map